import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import { useApplicationFetchers } from '../../../fetchers/use-application-fetchers';
import { companySettingsKeys } from '../query-keys';
import type { InvitationOptions } from './types';

export const useInvitationOptions = (enabled = true): UseQueryResult<InvitationOptions, Error> => {
    const { fetchInvitationOptions } = useApplicationFetchers();

    return useQuery({
        enabled,
        queryFn: async () => {
            const result = await fetchInvitationOptions();

            if (result.isErr) {
                throw result.error;
            }

            return result.value;
        },
        queryKey: [...companySettingsKeys.userManagement(), 'invitation-options'] as const,
        throwOnError: false,
    });
};
